import { AgGridColumnDef } from '@tassat/common-definitions';

import { obscureAccountNo } from 'Lib/stringHelpers';

export const columnDefs: AgGridColumnDef[] = [
    {
        field: 'AccountName',
        headerName: 'BD Account Name',
        sortingOrder: [ 'asc', 'desc' ],
        menuTabs: [],
        flex: 8
    },
    {
        field: 'Account',
        headerName: 'Acct Number',
        valueGetter: (params) => obscureAccountNo(params.data.Account),
        menuTabs: ['filterMenuTab'],
        flex: 8
    },
    {
        field: 'PrimaryAccount',
        headerName: 'Primary Account',
        cellRenderer: 'primaryWalletCellRenderer',
        menuTabs: [],
        flex: 8
    },
    {
        field: 'LastActivity',
        headerName: 'Last Activity',
        cellRenderer: 'lastTransactionDateCellRenderer',
        valueGetter: ({ data, context }) => context.wallets
            .find((walletMapped) => walletMapped.wallet?.LinkedAccount?.AccountId === data.AccountId),
        menuTabs: ['filterMenuTab'],
        flex: 8
    },
    {
        field: 'Status',
        headerName: '',
        cellRenderer: 'walletStatusCellRenderer',
        menuTabs: [],
        flex: 3
    },
    {
        field: 'IsClosed',
        colId: 'IsClosed',
        filter: 'agTextColumnFilter',
        headerName: 'Account Closed Status',
        hide: true
    }
];